import { z } from "zod"

import { propertyKeySchema } from "./property-key"

export const PROFILE_PROPERTIES = [
  `azimuth`,
  `climateDataFileName`,
  `derate`,
  `inverterEfficiency`,
  `losses`,
  `moduleType`,
  `systemSize`,
  `systemYield`,
  `tilt`,
  `trackMode`,
] as const

export const ProfileProperties = z.enum(PROFILE_PROPERTIES)

export const profilePropertiesSchema = z.object({
  azimuth: propertyKeySchema.optional(),
  climateDataFileName: propertyKeySchema.optional(),
  derate: propertyKeySchema.optional(),
  inverterEfficiency: propertyKeySchema.optional(),
  losses: propertyKeySchema.optional(),
  moduleType: propertyKeySchema.optional(),
  systemSize: propertyKeySchema.optional(),
  systemYield: propertyKeySchema.optional(),
  tilt: propertyKeySchema.optional(),
  trackMode: propertyKeySchema.optional(),
})

export type ProfileProperties = z.infer<typeof profilePropertiesSchema>
